define('views/modules/feedback/blocks/feeling',[
    // Libs
    'jquery', 'underscore', 'backbone', 'mustache', 'utils',
    // views
    'views/parts/info-section',
    'views/parts/form/sliderbar',
    // templates
    'text!templates/modules/feedback/blocks/feeling.html'

], function(
    // Libs
    $, _, Backbone, Mustache, U,
    // views
    VInfoSection,
    VSliderbar,
    // templates
    TFeeling
) {

    var VFeeling = Backbone.View.extend({

        template: TFeeling,
        events: {
            // 'event:name .event-selector': 'callback'
        },

        // abstracting selectors out of the view logic
        regions: {
            feeling: "#feedback-feeling"
        },

        initialize: function() {

            // namespace views inside an object.
            this.view = {
                info: new VInfoSection({
                    title: "How do you feel?",
                    content: this.template,
                }),
                feeling: new VSliderbar({
                    labels: ["Feel bad", "I'm ok", "Feel good"],
                    color: true,
                    model: this.model,
                    className: 'slider-feedback',
                    attribute: "feedback_level"
                })
            };

        },

        render: function() {

            this.assign(this.view.info, this.$el)
                .generateZones()
                .assign(this.view.feeling, this.zone.$feeling);

            return this;
        },

        getValue: function() {
            return this.view.feeling.getValue();
        },

        toggleDisabled: function(val) {
            this.view.feeling.toggleDisabled(val);
            this.$el.toggleClass("disabled", val);
        },

        toggle: function(val) {
            this.$el.toggleClass('hidden', val);
        },

        onSubmit: function() {
            this.model.setFeedbackLevel(this.view.feeling.getValue());
        }

    });

    return VFeeling;

});

